module.exports = __webpack_public_path__ + "media/images/job_arrow-96767facb0ebe260691be3afb80e3a96.png";